(function () {
  var heatmap_loaded = false;

  function loadHeatmap() {
    if (heatmap_loaded) return;
    heatmap_loaded = true;

    /* >> Heatmap.com :: Snippet << */
    (function (h,e,a,t,m,ap) { (h._heatmap_paq = []).push([ 'setTrackerUrl', (h.heatUrl = e) + a]); h.hErrorLogs=h.hErrorLogs || []; ap=t.createElement('script');  ap.src=h.heatUrl+'preprocessor.min.js?sid='+m;  ap.defer=true; t.head.appendChild(ap); ['error', 'unhandledrejection'].forEach(function (ty) {     h.addEventListener(ty, function (et) { h.hErrorLogs.push({ type: ty, event: et }); }); });})(window,'https://dashboard.heatmap.com/','heatmap.php',document,5440);
  }

  function analyticsAllowed() {
    var privacy_api = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy_api) return false;
    return privacy_api.analyticsProcessingAllowed();
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    if (event.detail.analyticsAllowed) loadHeatmap();
  });

  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) return;
        if (analyticsAllowed()) loadHeatmap();
      }
    );
  }
})();